import React, {useEffect, useState} from "react";
import {BlockContainer, PageContainer,} from "BaseComponents/Wrappers";
import {FlexContainer} from "BaseComponents/Flex";
import {H1, Ingress} from "BaseComponents/Text/";
import {useGlobal} from "reactn";
import {MapBlock} from "Blocks";
import {MapDropdowns} from "Components/LeafletMap/components/MapDropdowns";
import {Leaflet, ResultCards} from "Components/LeafletMap/";

let MapPage = ({
                   Heading,
                   Preamble,
                   MapHits,
                   DirectionsLinkText,
                   Breadcrumbs,
                   SearchMunicipality,
                   SearchMunicipalityHint,
                   SearchUnit,
                   SearchUnitHint,
                   NoHits,
                   FindUnitText,
                   ActivateMapText,
                   OverlayImage,
                   PreschoolTypes,
                   SearchTypeLabel,
                   SearchTypeHint,
                   ShowPreschoolTypes,
                   ShowUnitTypes,
                   BackgroundColor,
                   SearchFieldText,
                   YouAreHereText,
                   SearchTextUnit,
                   MapHeading,
                   Countries = [],
                   UseNewStyle,
                   UseNewCardStyle,
                   OverlayDisabled
               }) => {

    const [markersData, setMarkersData] = useState(MapHits);
    const [unit, setUnit] = useState({});
    const [municipality, setMunicipality] = useState({});
    const [theme] = useGlobal("theme");
    const [mapHitsState, setMapHitsState] = useState(MapHits);
    const [municipalities, setMunicipalities] = useState();
    const [units, setUnits] = useState([]);
    const [types, setTypes] = useState([]);
    const [typeState, setTypeState] = useState([]);
    const [isVisible, setIsVisible] = useState(OverlayDisabled);

    const rest = {
        SearchMunicipality,
        SearchMunicipalityHint,
        SearchUnit,
        SearchUnitHint,
        SearchTypeLabel,
        SearchTypeHint,
        NoHits,
        ShowPreschoolTypes,
        ShowUnitTypes,
    };

    const searchCallback = (data, isEmpty) => {
        if (data.length || (!data.length && !isEmpty)) {
            setMarkersData(data);
        } else {
            setMarkersData(MapHits);
        }
    }

    const municipalityEmpty = (municipality) =>
        Object.keys(municipality).length === 0;

    const selectedNullOrClear = (selected) => {
        let ret = false;
        if (selected !== null && selected.value === undefined) {
            ret = selected.length === 0 && selected.length !== undefined;
        }
        if (!ret) ret = selected === null;
        return ret;
    };

    const onChange = (selected, type) => {
        let sortedMarkersData = [];
        if (!selectedNullOrClear(selected)) {
            switch (type) {
                case "municipality":
                    sortedMarkersData = MapHits.filter(
                        ({Municipality, LocationForFiltering}) => {
                            let filterBy = LocationForFiltering?.length
                                ? LocationForFiltering
                                : Municipality;
                            return filterBy === selected.value;
                        }
                    );
                    setMarkersData(sortedMarkersData);
                    setMapHitsState(sortedMarkersData);
                    setMunicipality(selected);
                    break;
                case "unit":
                    let tmp;
                    if (municipalityEmpty(municipality)) {
                        tmp = MapHits.filter((unit) => unit.Name === selected.value);
                        if (tmp !== null) {
                            setMunicipality({
                                value: tmp[0].Municipality,
                                label: tmp[0].Municipality,
                            });
                            setMapHitsState(tmp);
                        }
                    }
                    setUnit(selected);
                    break;
                case "preSchoolType":
                    if (municipalityEmpty(municipality)) {
                        sortedMarkersData = MapHits.filter((el, i) =>
                            el.PreschoolType.some((p) =>
                                selected.map((s) => s.value).includes(p)
                            )
                        );
                        setMapHitsState(sortedMarkersData);
                        setMarkersData(sortedMarkersData);
                    } else if (!municipalityEmpty(municipality)) {
                        const s = selected.map((s) => s.value);
                        sortedMarkersData = markersData.filter((el, i) =>
                            el.PreschoolType.some((p) => s.includes(p))
                        );
                        setMapHitsState(sortedMarkersData);
                    }
                    setTypeState(selected);
                    break;
            }
        } else {
            if (type === "municipality") {
                setMunicipality({});
                setMarkersData(MapHits);
                setMapHitsState(MapHits);
                setUnit({});
                setTypeState({});
            }
            if (type === "unit") {
                if (!municipalityEmpty(municipality)) {
                    setMarkersData(markersData);
                    setMapHitsState(markersData);
                } else if (municipalityEmpty(municipality)) {
                    setMapHitsState(MapHits);
                    setMarkersData(MapHits);
                }
                setUnit({});
                setTypeState({});
            }
            if (type === "preSchoolType") {
                if (municipalityEmpty(municipality)) {
                    setMapHitsState(MapHits);
                    setMarkersData(MapHits);
                } else {
                    setMarkersData(markersData);
                    setMapHitsState(markersData);
                }
                selected === null && setTypeState([]);
                setUnit({});
            }
        }
    };

    const constructMunicipalities = (list) => {
        let newMunicipalityList = [];
        list.map(({Municipality, LocationForFiltering}, i) => {
            newMunicipalityList.push({
                value: LocationForFiltering?.length
                    ? LocationForFiltering
                    : Municipality,
                label: LocationForFiltering?.length
                    ? LocationForFiltering
                    : Municipality,
            });
        });
        const sortedMunicipalities = newMunicipalityList
            .filter(
                (el, i) =>
                    i === newMunicipalityList.findIndex((elem) => elem.value === el.value)
            )
            .sort((a, b) => a.label && a.label.localeCompare(b.label));
        setMunicipalities(sortedMunicipalities);
    };

    const constructUnits = () => {
        let newUnitsList = [];
        markersData.map(({Name}, i) => {
            newUnitsList.push({
                value: Name,
                label: Name,
            });
        });
        setUnits(newUnitsList);
    };

    const constructTypes = () => {
        let typesList = [];
        PreschoolTypes &&
        markersData.map(({PreschoolType}, i) => {
            PreschoolType?.length > 0 &&
            PreschoolType.map((p) => {
                !typesList.includes(p) && typesList.push({value: p, label: p});
            });
        });
        const uniqueTypes = typesList.filter(
            (el, i) => i === typesList.findIndex((elem) => elem.value === el.value)
        );

        setTypes(uniqueTypes);
    };

    useEffect(() => {
        constructMunicipalities(markersData);
        constructTypes(markersData);
    }, []);

    useEffect(() => {
        constructUnits(markersData);
        constructTypes(markersData);
    }, [municipality]);

    useEffect(() => {
        if (unit.label !== undefined) {
            let _unit = MapHits.filter(
                (el, i) => i === MapHits.findIndex((elem) => elem.Name === unit.label)
            );
            setMarkersData(_unit);
        }
    }, [unit]);
    const handleOverlay = () => {
        if (!isVisible) setIsVisible(true);
    };

    const carView = () => {
        return <ResultCards
            markersData={markersData}
            margin="1rem"
            DirectionsLinkText={DirectionsLinkText}
            UseNewCardStyle={UseNewCardStyle}
        />
    }

    return (
        <>
            {/*<BreadcrumbsComp Items={Breadcrumbs} />*/}
            {!UseNewStyle ? (
                    <>
                        <PageContainer bgColor={theme.colors.lightgrey}>
                            <FlexContainer
                                column
                                maxwidth="1252px"
                                smallmargin="0 1rem"
                                margin="0 auto"
                                smallwidth="auto"
                            >
                                <FlexContainer column smallmargin="0" smallwidth="auto" width="auto">
                                    {Heading && <H1>{Heading}</H1>}
                                    {Preamble && (
                                        <Ingress maxwidth="870px" margin="0 0 2rem 0">
                                            {Preamble}
                                        </Ingress>
                                    )}
                                    <Leaflet
                                        height="500px"
                                        borderradius={theme.border.radius}
                                        zoom={4}
                                        width="100%"
                                        center={[55.505, 9.09]}
                                        markersData={mapHitsState}
                                        nearestMarkers={markersData}
                                        DirectionsLinkText={DirectionsLinkText}
                                        FindUnitText={FindUnitText}
                                        ActivateMapText={ActivateMapText}
                                        handleOverlay={handleOverlay}
                                        isVisible={isVisible}
                                        OverlayImage={OverlayImage}
                                        ShowLocationButton
                                    ></Leaflet>
                                    <MapDropdowns
                                        handleOverlay={handleOverlay}
                                        municipalities={municipalities}
                                        types={types}
                                        units={units}
                                        onChange={(selected, type) => onChange(selected, type)}
                                        {...rest}
                                    />
                                </FlexContainer>
                            </FlexContainer>
                        </PageContainer>
                        <BlockContainer>
                            <FlexContainer backgroundImage="white" column>
                                <FlexContainer
                                    maxwidth="1250px"
                                    column
                                    smallmargin="0"
                                    margin="0 auto"
                                    smallwidth="auto"
                                    smallpadding="2rem 0"
                                    padding="2rem 0 4rem 0"
                                >
                                    {carView()}

                                </FlexContainer>
                            </FlexContainer>
                        </BlockContainer>
                    </>
                ) :
                (
                    <>
                        <PageContainer bgColor={theme.colors.lightgrey}>
                            <FlexContainer
                                column
                                maxwidth="1252px"
                                smallmargin="0 1rem"
                                margin="0 auto"
                                smallwidth="auto"
                            >
                                {Heading && <H1>{Heading}</H1>}
                                {Preamble && (
                                    <Ingress maxwidth="870px" margin="0 0 0.75rem 0">
                                        {Preamble}
                                    </Ingress>
                                )}
                                <MapBlock
                                    Heading={MapHeading}
                                    MapHits={MapHits}
                                    Countries={Countries}
                                    NoHits={NoHits}
                                    BackgroundColor={'transparent'}
                                    OverlayImage={OverlayImage}
                                    ActivateMapText={ActivateMapText}
                                    DirectionsLinkText={DirectionsLinkText}
                                    SearchFieldText={SearchFieldText}
                                    FindUnitText={FindUnitText}
                                    YouAreHereText={YouAreHereText}
                                    PreschoolTypes={PreschoolTypes}
                                    TypeText={SearchTypeHint}
                                    TypeHeading={SearchTypeLabel}
                                    ShowPreschoolTypes={ShowPreschoolTypes}
                                    SearchHintUnit={SearchUnitHint}
                                    SearchTextUnit={SearchTextUnit}
                                    ShowUnitTypes={ShowUnitTypes}
                                    searchCallback={searchCallback}
                                    OverlayDisabled={OverlayDisabled}
                                />
                            </FlexContainer>
                        </PageContainer>
                        <BlockContainer>
                            <FlexContainer backgroundImage="white" column>
                                <FlexContainer
                                    maxwidth="1250px"
                                    column
                                    smallmargin="0"
                                    margin="0 auto"
                                    smallwidth="auto"
                                    smallpadding="2rem 0"
                                    padding="2rem 0 4rem 0"
                                >
                                    {carView()}
                                </FlexContainer>
                            </FlexContainer>
                        </BlockContainer>
                    </>
                )}
        </>
    );
};

export default MapPage;
